import React from 'react'
import { NavigationTabs } from './NavigationTabs'
import { CirclesChallenges } from './CirclesChallenges'
import { CirclesCountries } from './CirclesCountries'
import { StateType } from '../state'
import { inject, observer } from 'mobx-react'
import { CirclesYears } from './CirclesYears'
import { CirclesSubsectors } from './CirclesSubsectors'
import { NavigationTabName } from '../constants'
import { ScrollableSelect } from '../../../components/ui/ScrollableSelect'
import { CHALLENGES, Challenge } from '../../../lib/constants'
import { capitalize } from 'lodash-es'

interface Props {
  state?: StateType
  showChallengeSwitcher: boolean
}
@inject('state')
@observer
export class TabCircles extends React.Component<Props> {
  render() {
    const { showChallengeSwitcher } = this.props
    const { Circles } = this.props.state
    const { setChallenge, selectedNavTab, challenge } = Circles

    return (
      <div className="remove-prod-margins">
        <div className={`f3 b tc mb4 mt3`}>
          {showChallengeSwitcher ? (
            <>
              Emissions breakdown for{' '}
              <ScrollableSelect
                className="di"
                dropdownClassName="f4 fw3 tl left-0"
                dropdownStyle={{ height: 212 }}
                valueClassName="di outline-0 pointer b--blue500 blue500 bg-white"
                value={challenge}
                options={CHALLENGES}
                getOptionLabel={(option) => capitalize(option)}
                onChange={(option) => setChallenge(option as any)}
              />
            </>
          ) : (
            'Global emission breakdown'
          )}
        </div>

        <NavigationTabs />
        {challenge && (
          <SelectedCircle tab={selectedNavTab} isChallengeSwitchable={showChallengeSwitcher} />
        )}
      </div>
    )
  }
}

interface PropsSelectedCircle {
  tab: NavigationTabName
  isChallengeSwitchable: boolean
}
function SelectedCircle({ tab, isChallengeSwitchable }: PropsSelectedCircle) {
  switch (tab) {
    case 'challenges':
      return <CirclesChallenges isChallengeSwitchable={isChallengeSwitchable} />
    case 'years':
      return <CirclesYears />
    case 'subsectors':
      return <CirclesSubsectors />
    case 'countries':
      return <CirclesCountries />
    default:
      throw new Error('Tab name unknown')
  }
}
